import React, {useContext, useEffect} from "react" ;
import AppBodyNotificationDropdown from "root/Wieldy/ApplicationModules/Common/Body/AppBodyNotificationDropdown";
import {useLocation} from "react-router-dom";
import queryString from "query-string";
import {PostMenuTitles, PostFilters, UserTypes} from "root/DataFunctions/Constants";
import GlobalContext from "root/contexts/GlobalContext";

const PostsAppBodyHeader= (props) =>
{
    const {search} = useLocation();
    const queryParams = queryString.parse(search);
    const globals = useContext(GlobalContext);

    const displayHeader = () =>
    {
        switch (queryParams.type)
        {
            case PostFilters.NEW:
                return <h4 className="title">Submitted</h4>
                break;

            case PostFilters.DISCUSSING:
                return <h4 className="title">{PostMenuTitles.DISCUSSING}</h4>
                break;

            case PostFilters.DRAFT:
                return <h4 className="title">{PostMenuTitles.DRAFT}</h4>
                break;

            case PostFilters.HELD:
                return <h4 className="title">{PostMenuTitles.HELD}</h4>
                break;

            case PostFilters.APPROVED:
                return <h4 className="title">{PostMenuTitles.APPROVED}</h4>
                break;

            case PostFilters.ARCHIVED:
                return <h4 className="title">{PostMenuTitles.ARCHIVED}</h4>
                break;

            case PostFilters.INCOMING:
                return <h4 className="title">{PostMenuTitles.INCOMING}</h4>
                break;

            case PostFilters.SENT:
                return <h4 className="title">{PostMenuTitles.SENT}</h4>
                break;

            default:
                if(globals.userType === UserTypes.CHILD)
                {
                    return <h4 className="title">{PostMenuTitles.INCOMING}</h4>
                }
                else{
                    return <h4 className="title">Submitted</h4>
                }
                break;
        }
    }

    return (
        <div className="dt-module__header d-none d-md-flex">

            <div className="child-menu-item">
                {displayHeader()}
            </div>

            {/*<AppBodyNotificationDropdown />*/}

        </div>
    ) ;
}

export default PostsAppBodyHeader;
